const GdodList = () => import('Views/gdod/gdod-list');
const GdodMetaDataDetail = () => import('Views/gdod/gdod-metaData-detail');

export default[
  { path: '/gdod-list', component: GdodList },
  { path: '/gdod-metaData-detail/:id', component: GdodMetaDataDetail },

];



// WEBPACK FOOTER //
// ./src/router/gdod.js